export default function ($http) {
    return function (accountId, model) {
        return $http({
            method: 'PUT',
            url: `/api/vmcaccount/${ accountId }`,
            data: model,
            headers: {
                'Content-Type': 'application/json'
            }
        })
		.then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/editVmcAccount/editVmcAccount.js